/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { useState, useContext } from 'react'
import { Button, Label, Input, FormGroup, Modal } from 'reactstrap'
import { apiUserLogin } from '../../services/api-service'
import { ModalContext } from '../../context/ModalContextProvider'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import { AuthContext } from '../../context/AuthContextProvider'
import PropTypes from 'prop-types'
import { trim } from 'lodash'

const MobileNumber = (props) => {
  const [mobileNumber, setMobileNumber] = useState('')
  const { setGlobalLoader, setGlobalMessage, setOtpTimerState } = useContext(MessageHandlerContext)
  const { otpModal, setOtpModal } = useContext(ModalContext)
  const { setMobileNumberState } = useContext(AuthContext)

  const handelOnInput = (event) => {
    setMobileNumber(event.target.value)
  }

  const submitMobileNumber = async () => {
    if (!trim(mobileNumber).match((/^((947|07|7)(0|1|2|4|5|6|7|8)[0-9]{7})$/))) {
      setGlobalMessage('Invalid phone number.')
      return
    }
    setGlobalLoader(true)
    try {
      const userLogin = await apiUserLogin({ mobile: trim(mobileNumber) })
      if (userLogin.status === 200) {
        setMobileNumberState(trim(mobileNumber))
        setOtpTimerState(60)
        props.toggle()
        setOtpModal(!otpModal)
      }
    } catch (error) {
      setGlobalMessage(error.message)
    } finally {
      setGlobalLoader(false)
    }
  }

  return (
    <Modal isOpen={props.opened} toggle={props.toggle} backdrop="static">
      <div className="login_otp">
        <div className="login_otp_wrapper">
          <FormGroup>
            <Label for="mobileNumber">Enter mobile number</Label>
            <Input type="tel" placeholder="07xxxxxxxx" autoComplete="off" onChange={(event) => handelOnInput(event)} />
          </FormGroup>
          <FormGroup className="mb-0">
            <Button color="warning" block onClick={() => submitMobileNumber()}>
              Submit
                    </Button>
          </FormGroup>
        </div>
      </div>
    </Modal>
  )
}

MobileNumber.propTypes = {
  opened: PropTypes.bool,
  toggle: PropTypes.func
}

export default MobileNumber
